export const enum InviteAgentsEvent {
  AddTeammate = 'Add teammate button clicked',
  SetUpChatbot = 'Set up ChatBot button clicked',
  NavigateToTeam = 'Navigate to team page',
}

export const COPILOT_ENABLED_OFFSET = '45px';
